export const CYRA_LOGO = "https://customer-assets-jai6qajn.emergentagent.net/job_krida-deploy/artifacts/ki3sgqq8_CYRA_logo_transparent_hi_res.webp";
